import React, { Component } from 'react';

import '../../stylesheets/countdown.css';

class Clock extends Component{
    constructor(props){
        super(props);
        this.state = {
            'd':null,
            'h':null,
            'm':null,
            's':null,
            // 'deadline':'December 25,2018',
            // 'newDeadline':null

        }
        this.interval=null;
    }
    getTimeUntil(deadline){
        //console.log(deadline);
        const time = Date.parse(deadline) - Date.parse(new Date());
        const s = Math.floor((time/1000)%60);
        const m = Math.floor((time/1000/60)%60);
        const h = Math.floor((time/(1000*60*60))%24);
        const d = Math.floor(time/(1000*60*60*24));
        //console.log(s,m,h,d);
        this.setState({s,m,h,d});
        //console.log(this.state);
    }

    leadingZero(num){
        return (num<10 && num>0) ? '0'+num : num
    }

    componentWillMount(){
        //this.getTimeUntil(this.props.deadline);
    }
    componentDidMount(){
        this.interval = setInterval(()=>this.getTimeUntil(this.props.deadline),1000);
        console.log(this.interval);
    }
    render(){
        //this.getTimeUntil(this.props.deadline);
        return(
            <div className='clock row'>
            <div className='d col-sm-3'>{this.leadingZero(this.state.d)} <small>days</small></div>
            <div className='h col-sm-3'>{this.leadingZero(this.state.h)} <small>hours</small></div>
            <div className='m col-sm-3'>{this.leadingZero(this.state.m)} <small>mins</small></div>
            <div className='s col-sm-3'>{this.leadingZero(this.state.s)} <small>secs</small></div>
            </div>
        )
    }
}

export default Clock;


// WEBPACK FOOTER //
// ./src/components/countdown/clock.jsx